import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            padding: '2rem',
            textAlign: 'center'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '3rem',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e9ecef',
                maxWidth: '600px',
                width: '100%'
            }}>
                <div style={{
                    fontSize: '4rem',
                    marginBottom: '1rem'
                }}>
                    🔒
                </div>

                <h1 style={{
                    fontSize: '2rem',
                    margin: '0 0 1rem 0',
                    color: '#495057'
                }}>
                    Access Denied
                </h1>

                <p style={{
                    fontSize: '1.1rem',
                    color: '#6c757d',
                    marginBottom: '2rem',
                    lineHeight: '1.5'
                }}>
                    You don't have permission to access this page.
                </p>

                <div style={{ display: 'flex', gap: '1rem', flexDirection: 'row', justifyContent: 'center' }}>
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            padding: '0.75rem 1.5rem',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '1rem'
                        }}
                    >
                        🏠 Return Home
                    </button>
                </div>

                <div style={{
                    marginTop: '2rem',
                    padding: '1rem',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    fontSize: '0.9rem',
                    color: '#6c757d'
                }}>
                    Error Code: 403 - Forbidden
                </div>
            </div>
        </div>
    );
};

export default AccessDeniedPage;